// extracted by mini-css-extract-plugin
module.exports = {"link":"Card_link__38er9","linkbox":"Card_linkbox__CxdAV","main":"Card_main__3s2Y1","name":"Card_name__2SJXv","dato":"Card_dato__1dHSr","cover":"Card_cover__2rsPu"};